import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { GoogleMapsLoaderService } from './google-maps-loader.service';

declare let google: any;

@Injectable()
export class DistanceService {
  private directionsService: any;

  constructor(private http: HttpClient, private googleMapsLoader: GoogleMapsLoaderService) {
    this.googleMapsLoader.load().then(() => {
      this.directionsService = new google.maps.DirectionsService();
    }).catch(error => {
      console.error('Erreur lors du chargement de Google Maps', error);
    });
  }

  async calculateDistance(departure: google.maps.LatLng, arrival: google.maps.LatLng): Promise<number> {
    try {
      const result = await this.directionsService.route({
        origin: departure,
        destination: arrival,
        travelMode: google.maps.TravelMode.DRIVING
      });
      const distanceInMeters = result.routes[0].legs[0].distance.value;
      return distanceInMeters / 1000; // Convertir en km
    } catch (error) {
      console.error('Erreur lors du calcul de la distance', error);
      return 0; // Retourner 0 en cas d'erreur
    }
  }

  getCoordinatesByCityIds(departureCityId: number, arrivalCityId: number): Promise<{ departure: google.maps.LatLng, arrival: google.maps.LatLng }> {
    return new Promise((resolve, reject) => {
      this.http.get<{ departure: { lat: number, lng: number }, arrival: { lat: number, lng: number } }>(`${environment.API_URL}/get-city-coords/${departureCityId}/${arrivalCityId}`)
        .subscribe(response => {
          console.log("response", response);
          if (response.departure.lng && response.departure.lat && response.arrival.lng && response.arrival.lat) {
            const departureLocation = new google.maps.LatLng(response.departure.lat, response.departure.lng);
            const arrivalLocation = new google.maps.LatLng(response.arrival.lat, response.arrival.lng);
            resolve({ departure: departureLocation, arrival: arrivalLocation });
          } else {
            reject("Erreur lors de la récupération des coordonnées");
          }
        }, error => {
          reject(`Erreur lors de la récupération des coordonnées: ${error.message}`);
        });
    });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/distanceService.ts